import router from '../router'

router.beforeEach((to, from, next) => {
  const metaTitles = {
    'home-index': '首页',
    'account-info': '个人信息',
    'account-mine': '个人中心',
    'article-detail': '协议详情',
    'article-protocol': '协议',
    'auth-login': '登录',
    'common-record': '课程记录',
    'course-courseDetail': '课程详情',
    'common-search': '搜索',
    'course-startStudy': '学习中心',
    'exchange-exchange': '兑换中心',
  }
  document.title = metaTitles[to.name] || '红商学院'
  next(true)
})
